const mutations = {
  mutationDocument(state, payload) {
    state.document = payload;
  },

  mutationCampaigns(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.campaigns[payload.tab] = payload.responseData;
    } else {
      state.campaigns = payload;
    }
  },

  mutationCampaignsMeta(state, payload) {
    state.campaignsMeta = payload;
  },

  mutationCampaignContacts(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.campaignContacts[payload.tab] = payload.responseData;
    } else {
      state.campaignContacts = payload;
    }
  },

  mutationCampaignContactsMeta(state, payload) {
    state.campaignContactsMeta = payload;
  },

  mutationTemplates(state, payload) {
    state.templates = payload;
  },

  mutationReports(state, payload) {
    if (typeof payload.tab !== "undefined" && payload.tab !== null) {
      state.reports[payload.tab] = payload.responseData;
    } else {
      state.reports = payload;
    }
  },

  mutationReportsMeta(state, payload) {
    state.reportsMeta = payload;
  },
};

export default mutations;
